import { useQuery } from 'react-query'
import axios from 'axios'
import { ROLEKEYS } from '../utils/Permissions.const'
import { useUser } from './useUser'

const endpoint = '/api/permissions'

export function usePageAccess(permissionKey) {
  const { user } = useUser()
  const { isLoading, data: response = {} } = useQuery({
    queryKey: [endpoint, user?._id],
    queryFn: () => axios.get(`${endpoint}/access`),
    enabled: Boolean(user?._id),
  })

  const { data = {} } = response

  const enabled = data.role === ROLEKEYS.ADMIN || data?.permissions?.includes(permissionKey)

  return {
    data,
    enabled,
    isLoading,
  }
}
